/** Min/max pixel widths for resizable client-list columns. */
export const CLIENT_TABLE_COLUMN_MIN_SIZE = 64;
export const CLIENT_TABLE_COLUMN_MAX_SIZE = 640;
export const CLIENT_TABLE_COLUMN_DEFAULT_SIZE = 140;

/**
 * @param {unknown} raw
 * @returns {Record<string, number>}
 */
export function sanitizeColumnWidths(raw) {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return {};
  const out = {};
  Object.entries(raw).forEach(([id, value]) => {
    if (typeof id !== 'string' || !id.trim()) return;
    const n = Number(value);
    if (!Number.isFinite(n)) return;
    out[id] = Math.min(
      CLIENT_TABLE_COLUMN_MAX_SIZE,
      Math.max(CLIENT_TABLE_COLUMN_MIN_SIZE, Math.round(n))
    );
  });
  return out;
}
